<template>
<div class="chapter">
<div class="inner_page">
<p class="center1" style="margin-top:6em;"><strong class="futur_bold">Other Li<img alt="" src="images/1.jpg"/> books by Mark Tatulli</strong></p>
<p class="center"><em class="futur_ital">Liō: Happiness Is a Squishy Cephalopod</em></p>
<p class="center"><em class="futur_ital">Silent But Deadly</em></p>
<p class="center"><em class="futur_ital">Liō’s Astonishing Tales</em></p>
<p class="center"><em class="futur_ital">There’s Corpses Everywhere</em></p>
<p class="center"><em class="futur_ital">Reheated Liō</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a1.vue?1a8a1621